export default __webpack_public_path__ + "static/media/property_706.3ad665c6.png";